import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocGlobalReportsHomePageNav4Route: InvariantJiraRoute = {
	name: 'eoc-global-reports',
	path: '/jira/ops/reports',
	exact: true,
};
